import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CreatePayslip = () => {
  const API_URL = window.__ENV__?.API_URL || "https://zcndj9z325.execute-api.ap-south-1.amazonaws.com/Prod/api";

  const [employees, setEmployees] = useState([]);
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    employee_id: '',
    name: '',
    account_number: '',
    month: '',
    total_days: 30,
    present_days: 30,
    leave_days: 0,
    basic: 0,
    hra: 0,
    conveyance: 0,
    leave_deduction: 0,
  });

  useEffect(() => {
    axios.get(`${API_URL}/employees`).then(res => setEmployees(res.data)).catch(console.error);
    fetchPayslips();
  }, [API_URL]);

  const fetchPayslips = async () => {
    try {
      const res = await axios.get(`${API_URL}/payslip`);
      setPayslips(res.data);
    } catch (err) {
      console.error("Error fetching payslips:", err);
    }
  };

  const calculate = () => {
    const leave_deduction = ((form.leave_days || 0) / form.total_days) * form.basic;
    const gross_salary = Number(form.basic) + Number(form.hra) + Number(form.conveyance);
    const total_earnings = gross_salary - leave_deduction;

    return {
      gross_salary,
      total_earnings,
      net_salary: total_earnings,
      leave_deduction: Number(leave_deduction.toFixed(2)),
    };
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = ['basic', 'hra', 'conveyance', 'leave_days', 'total_days', 'present_days'].includes(name)
      ? Number(value)
      : value;

    setForm(prev => {
      const updated = { ...prev, [name]: parsedValue };
      if (name === 'leave_days' || name === 'basic' || name === 'total_days') {
        const { leave_deduction } = calculate();
        updated.leave_deduction = leave_deduction;
      }
      return updated;
    });
  };

  const handleSubmit = async () => {
    if (!form.employee_id || !form.month) {
      alert('❌ Please select an employee and month.');
      return;
    }

    const { gross_salary, total_earnings, net_salary, leave_deduction } = calculate();

    const payload = {
      ...form,
      gross_salary,
      leave_deduction,
      earning_basic: form.basic,
      earning_hra: form.hra,
      earning_conveyance: form.conveyance,
      total_earnings,
      net_salary,
    };

    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/payslip`, payload);

      alert('✅ Payslip created successfully');

      // Open PDF in a new tab
      const blob = new Blob([res.data.pdf], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');

      fetchPayslips(); // Refresh payslip list
      setForm({
        employee_id: '',
        name: '',
        account_number: '',
        month: '',
        total_days: 30,
        present_days: 30,
        leave_days: 0,
        basic: 0,
        hra: 0,
        conveyance: 0,
        leave_deduction: 0,
      });
    } catch (err) {
      console.error('Error creating payslip:', err);
      alert('❌ Error creating payslip');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <h2>Create Payslip</h2>

      <label>Employee:</label>
      <select
        name="employee_id"
        value={form.employee_id}
        onChange={(e) => {
          const emp = employees.find(emp => emp.employee_id === e.target.value);
          if (emp) {
            setForm(prev => ({
              ...prev,
              employee_id: emp.employee_id,
              name: emp.name,
              account_number: emp.account_number,
            }));
          }
        }}
      >
        <option value="">-- Select Employee --</option>
        {employees.map(emp => (
          <option key={emp.employee_id} value={emp.employee_id}>
            {emp.name} ({emp.employee_id})
          </option>
        ))}
      </select>

      <br /><br />
      <label>Month (YYYY-MM):</label>
      <input type="month" name="month" value={form.month} onChange={handleChange} /><br /><br />

      <label>Total Days:</label>
      <input type="number" name="total_days" value={form.total_days} onChange={handleChange} /><br />
      <label>Present Days:</label>
      <input type="number" name="present_days" value={form.present_days} onChange={handleChange} /><br />
      <label>Leave Days:</label>
      <input type="number" name="leave_days" value={form.leave_days} onChange={handleChange} /><br />
      <label>Leave Deduction:</label>
      <input type="number" name="leave_deduction" value={form.leave_deduction} readOnly /><br /><br />

      <label>Basic:</label>
      <input type="number" name="basic" value={form.basic} onChange={handleChange} /><br />
      <label>HRA:</label>
      <input type="number" name="hra" value={form.hra} onChange={handleChange} /><br />
      <label>Conveyance:</label>
      <input type="number" name="conveyance" value={form.conveyance} onChange={handleChange} /><br /><br />

      <button onClick={handleSubmit} disabled={loading}>
        {loading ? 'Submitting...' : 'Submit Payslip'}
      </button>

      <hr />
      <h3>Existing Payslips</h3>
      {payslips.length === 0 ? (
        <p>No payslips found.</p>
      ) : (
        <table border="1" width="100%" style={{ marginTop: '10px' }}>
          <thead>
            <tr>
              <th>Employee</th>
              <th>Month</th>
              <th>Basic</th>
              <th>Gross</th>
              <th>Net</th>
              <th>PDF</th>
            </tr>
          </thead>
          <tbody>
            {payslips.map((ps, idx) => (
              <tr key={idx}>
                <td>{ps.name}</td>
                <td>{ps.month}</td>
                <td>{ps.earning_basic}</td>
                <td>{ps.gross_salary}</td>
                <td>{ps.net_salary}</td>
                <td>
                  <a href={`${API_URL}/payslip/pdf/${ps.id}`} target="_blank" rel="noreferrer">
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CreatePayslip;
